import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"

export const AboutWrapper = styled.section`
    height: auto;
    width: 100%;
    margin-top: -160px;
    background-color: #100138;
    margin-bottom: 300px;

    ${media.lessThan("lg")`
        margin-bottom: 170px;
    `} 

    ${media.lessThan("md")`
        margin-bottom: 0px;
    `}

    ${media.lessThan("sm")`
        margin-bottom: 50px;
    `} 


    @media screen and (min-width: 2100px){
        margin-bottom: 400px;
    }

`

export const CurveTop = styled(Img)`
  position: absolute;
  top: 170px;
  left: -5px;
  width: 100%;
  transform: translateY(-100%);
  z-index: 3;

  ${media.lessThan("md")`
        width: 110%;
        left: -10%;
    `}
`

export const CurveBottom = styled(Img)`
  position: absolute;
  bottom: 7px;
  left: 0;
  width: 100%;
  transform: translateY(100%);
  z-index: 3;

  @media screen and (min-width: 1600px) {
    bottom: 10px;
  }

  ${media.lessThan("md")`
       bottom: 2px;
    `}
`

export const AboutContent = styled.div`
    height: auto;
    padding-top: 50px;

    ${media.lessThan("xl")`
       padding-top: 90px;
        text-align: center;
    `} 

    ${media.lessThan("md")`
        padding-top: 200px;
    `} 

    ${media.lessThan("sm")`
        padding-top: 170px;
    `} 
`

export const AboutCaption = styled.div`
  position: relative;
  padding-right: 10px;
  z-index: 4;
  color: #fff;
`

export const AboutTitle = styled.h2`
  font-size: 64px;
  font-weight: 600;
  line-height: 0.8;
  margin-bottom: 25px;
  letter-spacing: 1.5px;
  color: #fff;

  ${media.lessThan("lg")`
        font-size: 50px;
        margin-bottom: 16px;
    `}

  ${media.lessThan("sm")`
        font-size: 40px;
    `}
`

export const AboutDesc = styled.p`
  font-weight: 300;
  letter-spacing: 1px;
  max-width: 380px;

  ${media.lessThan("md")`
       text-align: center;
    `}

  ${media.lessThan("md")`
       font-size: 16px;
    `}
`

export const AboutHero = styled(Img)`
  display: ${props => (props.isMobile ? "none" : "block")};
  margin: 0 auto;
  margin-top: -70px;
  width: 68%;
  animation: float 3s infinite;
  z-index: 4;

  ${media.lessThan("lg")`
       display: ${props => (props.isMobile ? "block" : "none")};
       margin-top: 30px;
       width: 40%;
    `}

  ${media.lessThan("sm")`
       margin-top: 40px;
       margin-bottom: 40px;
       width: 70%;
    `}
`
